<template>
  <div class="main" @click.self="$emit('close')">
    <div class="box-modal">
      <div class="title">انتخاب کوین</div>

      <div v-for="(item , index) in items" :key="index" @click="selectfunction(item)" class="coins">
        <inline-svg :src="require('../../../assets/coins/' + item.logo + '.svg')"/>
        <div class="name-coin">
          <span>{{item.name}}</span>
           <small>{{item.relationName}}</small>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "pay-otc-modal",
  data(){
    return{
      select:'',
      items:[
        {
          name:'تومان' , relationName:'TMN' , logo:'TOMAN',value:"TOMAN"
        },

        {
          name:'تتر' , relationName:'USDT' , logo:'USDT', value:"TETHER"
        },
      ]
    }
  },

  methods:{
    selectfunction(e){
      this.select = e;
      this.$emit('choise' , this.select)
    },
  }
}
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

  .box-modal {
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 28px;
    width: 367px;
    max-height: 450px;
    overflow: auto;

    .coins{
      display: flex;
      flex-direction: row;
      gap: 10px;
      height: 40px;
      align-items: center;
      margin-bottom: 10px;
      padding: 5px;
      cursor: pointer;

      .name-coin{
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100px;
        text-align: right;
      }

      &:hover{
        background-color: rgba(215, 200, 200, 0.12);;
      }

      svg{
        width: 30px;
        height: 30px;
      }

      span{
        font-size:clamp(12px , 1vw , 16px);
        color:#FFFFFF;
      }

      small{
        color: rgba(215, 200, 200, 1);
      }
    }
  }
}
</style>